import { useEffect } from "react";
import { useParams, useLocation } from "wouter";

/**
 * Legacy deeplink alias — early Notification Hub pings used
 * `/email-drafts/:draftId`. The canonical surface is now the Drafts tab
 * in the Email Hub. Redirect with the draftId preserved so any
 * outstanding notifications still land the user on the right draft.
 */
export default function EmailDraftRetryPage() {
  const params = useParams<{ draftId: string }>();
  const [, setLocation] = useLocation();

  useEffect(() => {
    const id = params.draftId;
    if (id) {
      setLocation(`/inbox?folder=outbox&draftId=${encodeURIComponent(id)}`);
    } else {
      setLocation("/inbox?folder=outbox");
    }
  }, [params.draftId, setLocation]);

  return null;
}
